import { RESERVED_DATA_ATTRIBUTES } from '../constants/dataAttributes';
import { devLog } from './devLog';
const RESERVED = new Set(RESERVED_DATA_ATTRIBUTES);

/**
 * Converts a Config API `dataAttributes` prop into DOM props. Only `data-*`
 * keys are kept; reserved keys (`RESERVED_DATA_ATTRIBUTES`: Base UI state
 * attributes and attributes Trellis owns) and keys without the `data-` prefix
 * are dropped with a dev warning, covering callers that bypass the type.
 *
 * Spread the result **before** the attributes the component owns
 * (`data-test-id`, `data-component`) so the component's values win.
 *
 * @example
 * <BoxRoot {...pickDataAttributes(dataAttributes)} data-test-id={dataTestId?.root} />
 */
export function pickDataAttributes(dataAttributes) {
  const result = {};
  if (!dataAttributes) return result;
  for (const [key, value] of Object.entries(dataAttributes)) {
    if (!key.startsWith('data-') || RESERVED.has(key)) {
      devLog(`dataAttributes: ignoring "${key}". Keys must start with "data-" and cannot be an attribute Trellis or Base UI owns (use \`dataTestId\` for "data-test-id").`);
      continue;
    }
    if (value !== undefined) {
      result[key] = value;
    }
  }
  return result;
}